export default __webpack_public_path__ + "static/media/jazzcash.21b1064e.svg";